import { createContext, useContext, type ReactNode } from "react"

import type { WorkspaceResource } from "@/types_api/backend/transport/list_workspaces_response"

export interface WorkspaceContextValue {
  currentWorkspace: WorkspaceResource | null
  /**
   * The workspace segment from the canonical URL.
   *
   * This is the workspace ID (`WorkspaceResource.id`), not the slug.
   */
  routeWorkspaceId: string | null
  workspaces: readonly WorkspaceResource[]
}

export const EMPTY_WORKSPACE_CONTEXT_VALUE: WorkspaceContextValue = {
  currentWorkspace: null,
  routeWorkspaceId: null,
  workspaces: [],
}

const WorkspaceContext = createContext<WorkspaceContextValue | null>(null)

export function WorkspaceProvider({
  children,
  value,
}: {
  children: ReactNode
  value: WorkspaceContextValue
}) {
  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  )
}

export const useOptionalWorkspaceContext = () => useContext(WorkspaceContext)

export const useWorkspaceContext = () => {
  const context = useContext(WorkspaceContext)
  if (!context) {
    throw new Error("useWorkspaceContext must be used within WorkspaceProvider")
  }
  return context
}
